


















import { Component, Mixins, Watch } from 'vue-property-decorator';
  import MainLayout from "./layouts/MainLayout.vue";
  import WebConferencesRecordingLayout from "./layouts/WebConferencesRecordingLayout.vue";
  import LoginLayout from "./layouts/LoginLayout.vue";
  import Spinner from './components/Spinner.vue';
  import {EventBus} from "@common/EventBus";
  import NoEvents from "./components/NoEvents.vue";
  import PeriodicRefreshMixin from "../mixins/PeriodicRefreshMixin";
  import AnalyticsMixin from "../mixins/AnalyticsMixin";
  import { AppVersionChecker } from "./helpers/AppVersionChecker"
  import { Route } from 'vue-router';
  import {RouteNamesEnum} from "@service/router/RouteNamesEnum";
  import {hasSessionParams} from "@share/auth/QueryHasSessionParamsHelper";
  import InitError from "@share/init-error/InitError.vue";
  import { ticketSystemIsEnabled } from '@common/serviceParamsHelper';
  import { noEventId } from "@service/router/getters";

  @Component({
    components: {
      InitError,
      MainLayout,
      WebConferencesRecordingLayout,
      LoginLayout, Spinner, NoEvents }
  })
  export default class App extends Mixins(PeriodicRefreshMixin, AnalyticsMixin) {
    static GA_EVENT_SEND_TIMEOUT = 120 * 1000;
    include = 'StageView,SessionView,ParticipantsView,Participants,PartnerView,MeetingsScheduleView';
    prevRouteName?: string | null = "";
    appVersionChecker?: AppVersionChecker;

    get isAuthed() {
      return this.$store.getters['isAuthed'];
    }

    get isRecordingPage() {
        return this.$route.name == RouteNamesEnum.webConferencesRecording;
    }

    get isMeetingRecording()
    {
        return this.$route.name == RouteNamesEnum.viewMeetingPublicRecording;
    }

    get ticketSystemIsEnabled() {
        return ticketSystemIsEnabled();
    }

    get layoutName() {
        if (this.$store.getters['isAuthed']) {
            return (this.isRecordingPage || this.isMeetingRecording || hasSessionParams(this.$route)) ? 'WebConferencesRecordingLayout' : 'MainLayout';
        }

        return 'LoginLayout';
    }

    get isLoading() {
      return this.$store.state.isLoading;
    }

    get eventId() {
      return this.$store.state.events.selected;
    }

    get noEvents() {
      return this.$route.params?.eventId == noEventId &&
          !this.ticketSystemIsEnabled &&
          !this.isRecordingPage &&
          !this.isMeetingRecording &&
          this.$store.state.events.isLoaded &&
          this.$store.state.events.list.length == 0;
    }

    get showLayout() {
      return (
        (
          (this.eventId && !this.noEvents) ||
          (this.isMeetingRecording) ||
          (this.ticketSystemIsEnabled && !!this.backend)
        ) && !this.couldNotInit ||
        this.layoutName == 'LoginLayout'
      )
    }

    get backend() {
        return this.$route.params.backend
    }

    get routeSubname() {
      return 'default';
    }

    get couldNotInit() {
      return this.$store.state.initErrors && this.$store.state.initErrors.length > 0;
    }

    get webPageParamsProjectName() {
        return this.$store.getters["services/getServiceParam"]('webClientPageParams', 'projectName');
    }

    get webPageParamsProjectFavicon() {
        return this.$store.getters["services/getServiceParam"]('webClientPageParams', 'faviconFileId');
    }

    @Watch('webPageParamsProjectName', { immediate: true })
    onProjectNameChange() {
        this.$store.dispatch('setPageTitle');
    }

    @Watch('webPageParamsProjectFavicon', { immediate: true })
    onFaviconChange() {
        this.$store.dispatch('setFavicon');
    }

    created() {
      if(process.env.NODE_ENV !== 'development') {
        this.appVersionChecker = new AppVersionChecker(this.$repositories);
      }
    }

    async mounted() {
      EventBus.$on('createMeetingWith', this.createMeetingWith);
      EventBus.$on('showChatByUserId', this.tryOpenChatRoom);
      EventBus.$on('showChatByProfileId', this.tryOpenChatRoomByProfileId);

      const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      if(!iOS) {
        const meta = document.querySelector('[name=viewport]') as HTMLElement,
              content = meta.getAttribute('content') || '';
        meta.setAttribute('content', content.split(',').filter(item => item.indexOf('user-scalable') === -1).join(','));
      }

      this.$analytics.bootstrap(this.$gtag);
      this.$analytics.setGtagParams();

      this.initRefresh(this.sendTrackingEvent, App.GA_EVENT_SEND_TIMEOUT);

      this.$router.afterEach(this.setPrevRouteName);

      this.appVersionChecker?.watch();
    }

    setPrevRouteName(to: Route, from: Route) {
      if(from.name !== "Chat") {
        this.prevRouteName = from.name;
      }
    }

    async tryOpenChatRoomByProfileId(profileId: string) {
      if(this.isChatAllowed) {

        const userId = await this.$store.dispatch('chat/profiles/fetchProfileById', profileId);

        if(userId) {
          this.tryOpenChatRoom(userId)
        }
        else {
          this.$store.dispatch('reportError', 'Пользователь не найден', { root: true });
        }
      }
    }

    async tryOpenChatRoom(userId: number) {
      if(this.isChatAllowed) {
        const rooms = this.$store.state.chat.rooms.list || []
        let roomId = rooms.find((room: any) => room.userId === userId)?.id;

        if(!roomId) {
          roomId = await this.$store.dispatch('chat/rooms/createRoomByUserId', userId);

          if(roomId) {
            this.openChat(roomId);
          }
        }
        else {
          this.openChat(roomId)
        }
      }
    }

    @Watch('isChatAllowed', { immediate: true })
    watchIsChatAllowed(value: boolean) {
      this.setCursorForChatOpening(value)
    }

    setCursorForChatOpening(isChatAllowed: boolean) {
      let r = document.querySelector<HTMLElement>(':root');

      if(isChatAllowed) {
        r?.style.setProperty('--chat-opening-cursor', 'pointer');
      }
      else {
        r?.style.setProperty('--chat-opening-cursor', 'default');
      }
    }

    get isChatAllowed() {
      //check the chat availability
      return this.$store.getters["events/isChatAllowed"];
    }

    async openChat(roomId: string) {
      if(roomId) {
        EventBus.$emit('openChatRoom', roomId);
      }
    }

    createMeetingWith(userId: string) {
      this.$router.push({
        name: this.$route.name || 'Home',
        params: this.$route.params,
        query: {
          userId: userId
        },
        hash: "#meetings"
      })
    }

    destroyed() {
      EventBus.$off('createMeetingWith', this.createMeetingWith);
      EventBus.$off('showChatByUserId', this.tryOpenChatRoom);
      EventBus.$off('showChatByProfileId', this.tryOpenChatRoomByProfileId);
      this.$analytics.uninstall();

      this.appVersionChecker?.stopWatching();
    }
  }
